module.exports = "https://static.wagwalking.com/_next/static/images/review4-43937003b8ba39ddec651e1baac1f10e.webp";